import { render, staticRenderFns } from "./tr-title.vue?vue&type=template&id=9f43e3b2&scoped=true&"
import script from "./tr-title.vue?vue&type=script&lang=js&"
export * from "./tr-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f43e3b2",
  null
  
)

export default component.exports